// src/store/thunks/sixDetail/getInitialDetailThunk.ts
import {
  mapSixActivitiesDTOToSixActivities,
  mapSixFilesApiResponseToFileEntries,
  mapSixSummaryDTOToSixDetailMeta,
  mapParticipantsPayloadDTOToParticipantsResponse,
} from '@/store/mappers/mapSixDetail';
import {
  FILE_LIST_TOPIC,
  FILE_TRANSFER_TOPIC,
} from '@/config/networkConstants';
import { initializeP2PStackThunk } from '@/store/thunks/poc/connection/initializeP2PStackThunk';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { syncFilesFromApiThunk } from '@/store/thunks/sixDetail/syncFilesFromApiThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { facilitateFileKeys } from '@/store/thunks/fileKey/facilitateFileKeysThunk';

export const initSixDetailThunk = createAppAsyncThunk(
  'sixDetail/initSixDetail',
  withLoader(
    async(sixIdentifier: string, { dispatch, extra, getState }) => {
      const rootState = getState();
      const activeFilters = rootState.sixDetail.activeFilters;

      const metaDTO = await extra.sixDetailService.getMeta(sixIdentifier, activeFilters);
      const bootstrapNodes = metaDTO.bootstrapNodes
        .map((bootstrapNode) => bootstrapNode.trim())
        .filter((bootstrapNode) => bootstrapNode.length > 0);

      if (bootstrapNodes.length > 0) {
        void dispatch(
          initializeP2PStackThunk({
            sixId: sixIdentifier,
            bootstrapNodes,
            swarmKey: metaDTO.swarmKey,
            fileListTopic: FILE_LIST_TOPIC(sixIdentifier),
            fileTransferTopic: FILE_TRANSFER_TOPIC,
            autoInitializeMessaging: true,
          })
        );
      }

      const filesResponse = await extra.sixDetailService.fetchFiles(sixIdentifier, {
        filters: activeFilters,
        path: undefined,
      });
      const activityDTO = await extra.sixDetailService.fetchActivity(sixIdentifier);
      const participantsPayload = await extra.sixDetailService.fetchParticipants(sixIdentifier);

      const meta = mapSixSummaryDTOToSixDetailMeta(metaDTO);
      const participants = mapParticipantsPayloadDTOToParticipantsResponse(participantsPayload);
      const activity = mapSixActivitiesDTOToSixActivities(activityDTO);
      const files = mapSixFilesApiResponseToFileEntries(filesResponse);
      if (typeof filesResponse.totalFileCount === 'number' && meta.fileCount === undefined) {
        meta.fileCount = filesResponse.totalFileCount;
      }

      void dispatch(syncFilesFromApiThunk({ sixId: sixIdentifier, files }));
      void dispatch(facilitateFileKeys());
      return {
        sixId: sixIdentifier,
        meta,
        files,
        activity,
        participants,
      };
    },
  ),
);
